import { render } from "./PageModalAduan.vue?vue&type=template&id=44fedd41"
import script from "./PageModalAduan.vue?vue&type=script&lang=js"
export * from "./PageModalAduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__